import { AlertTriangleIcon, CpuIcon } from "lucide-react";
import { Button } from "react-aria-components";

import { Badge } from "@/components/ui/badge";
import { NavList, NavListItem } from "@/components/ui/nav-list";
import { Text } from "@/components/ui/text";
import type { TInstrumentResultSet } from "@/lib/types";
import { format } from "@/lib/utils";
import { InstrumentResultSetDialog } from "./dialogs/InstrumentResultSetDialog";

export function InstrumentResultList({
  resultSets,
}: {
  resultSets: TInstrumentResultSet[];
}) {
  return (
    <NavList items={resultSets} className="mt-1 border-b-0">
      {(resultSet) => {
        const errorCount = resultSet.results.filter(
          (r) => r.resultType === "error",
        ).length;
        return (
          <NavListItem key={resultSet.id} asChild>
            <InstrumentResultSetDialog resultSet={resultSet}>
              <Button className="flex justify-between items-center w-full gap-4 border rounded-md px-4 h-10 shadow-xs cursor-pointer hover:bg-muted/50 [&+&]:mt-1 outline-hidden focus-visible:ring-2 ring-ring">
                <div className="flex items-center gap-2 min-w-0 flex-nowrap">
                  <CpuIcon className="shrink-0 size-4" />
                  <Text size="1" truncate elementType="span">
                    {resultSet.instrument?.model || "Unknown instrument"}
                  </Text>
                  <Badge size="sm">
                    {resultSet.results.length} result
                    {resultSet.results.length !== 1 ? "s" : ""}
                  </Badge>
                  {errorCount > 0 && (
                    <Badge color="red" size="sm">
                      <AlertTriangleIcon className="size-3" />
                      {errorCount} error{errorCount !== 1 ? "s" : ""}
                    </Badge>
                  )}
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <Text size="1" mono muted className="shrink-0">
                    {format(resultSet.createdAt)}
                  </Text>
                </div>
              </Button>
            </InstrumentResultSetDialog>
          </NavListItem>
        );
      }}
    </NavList>
  );
}
